import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import BasicFormControlClass from './BasicFormControl';
import HtmlControlClass from './HtmlControl';
import EdgesInputStyleClass from './EdgesInputStyle';
import FlatInputStyleClass from './FlatInputStyle';
import RaiseInputStyleClass from './RaiseInputStyle';
import SolidInputStyleClass from './SolidInputStyle';
import InputSizingClass from './InputSizing';
import CustomControlsClass from './CustomControls';

const BaseInput = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Base Inputs' parent='Form Controls' title='Base Inputs' />
      <Row>
        <Col sm='12'>
          <BasicFormControlClass />
        </Col>
        <Col sm='12'>
          <HtmlControlClass />
        </Col>
        <Col md='6'>
          <EdgesInputStyleClass />
        </Col>
        <Col md='6'>
          <FlatInputStyleClass />
        </Col>
        <Col md='6'>
          <RaiseInputStyleClass />
        </Col>
        <Col md='6'>
          <SolidInputStyleClass />
        </Col>
        <Col sm='12'>
          <InputSizingClass />
        </Col>
        <Col sm='12'>
          <CustomControlsClass />
        </Col>
      </Row>
    </Container>
  );
};

export default BaseInput;
